import { packNetAxios } from "@/lib/api-client";
import { type FusionMachine } from "@/schemas";

import { baseRoutes } from "../base-routes";

const fusionApi = `${baseRoutes.fusion}/api/v1/machines`;

export async function getFusionMachines(): Promise<FusionMachine[]> {
	const response = await packNetAxios.get<FusionMachine[]>(fusionApi);
	return response.data.map((machine) => ({ ...machine, machineType: "Fusion" as const }));
	// return z.array(fusionMachineSchema).parse(response.data); // TODO: Test parse
}

export async function deleteFusionMachine(id: string): Promise<void> {
	await packNetAxios.delete(`${fusionApi}/${id}`);
}

// Service mode operations
export async function enterFusionServiceMode(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/enterservicemode`, {});
}

export async function leaveFusionServiceMode(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/leaveservicemode`, {});
}

// Track operations
export async function activateFusionPressureRoller(machineId: string, trackNumber: number): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/tracks/${trackNumber}/activatepressureroller`, {});
}

export async function deactivateFusionPressureRoller(machineId: string, trackNumber: number): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/tracks/${trackNumber}/deactivatepressureroller`, {});
}

export async function feedRollerForward(machineId: string, trackNumber: number): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/tracks/${trackNumber}/feedforward`, {});
}

// CrossHead operations
export async function activateFusionCrossheadKnife(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/activatecrossheadknife`, {});
}

export async function deactivateFusionCrossheadKnife(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/deactivatecrossheadknife`, {});
}

export async function activateFusionCrossheadLatch(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/activatecrossheadlatch`, {});
}

export async function deactivateFusionCrossheadLatch(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/deactivatecrossheadlatch`, {});
}

// Calibration and cycle operations
export async function calibrateFusion(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/calibrate`, {});
}

export async function cycleFusionCrossheadTools(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/cycleallcrossheadtools`, {});
}

export async function cycleFusionTrackTools(machineId: string): Promise<void> {
	await packNetAxios.post(`${fusionApi}/${machineId}/cyclealltracktools`, {});
}

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.fusion}/api/v1/version`);
	return response.data;
}
